export default "__VITE_ASSET__BVZgZDy9__"